module.exports = __webpack_public_path__ + "static/media/team.7f43d61f.svg";